import type { OnlineGameMode } from './types';

// Alphanumeric alphabet without easily confused characters (no 0/O, 1/I/L)
const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

/**
 * Generate a clean, 4-character room code.
 */
export function generateRoomCode(): string {
  let code = '';
  for (let i = 0; i < 4; i++) {
    const idx = Math.floor(Math.random() * ROOM_CODE_ALPHABET.length);
    code += ROOM_CODE_ALPHABET[idx];
  }
  return code;
}

/**
 * Sanitize user input for room codes.
 */
export function sanitizeRoomCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
}

/**
 * Create a namespaced PeerJS ID for the host.
 */
export function getHostPeerId(mode: OnlineGameMode, code: string): string {
  return `findsets-v1-${mode}-${code.toUpperCase()}`;
}

